module.exports = __webpack_public_path__ + "img/back.52ea8e15.jpg";